import { State } from './state'

export interface Address {
    id: number,
    line1: string,
    line2?: string,
    city: string,
    state: State,
    zip: string,
    zip4: string
}

export interface AddressRequest {
    id: number,
    line1: string,
    line2?: string,
    city: string,
    stateCode: string,
    zip: string,
    zip4: string
}


export function blankAddress(): Address {
    return {
        state: {} as State,
    } as Address
}
